<i
  class="far fa-question-circle info-button"
  [pTooltip]="helperText"
  tooltipPosition="bottom"
></i>
